module.exports = __webpack_public_path__ + "static/media/hackerbank_logo.7b1d2c26.png";